<uni-text-body
  [color]="getColor(isActive, isDisabled, isHover)"
  [weight]="getWeight(isActive)"
  (mouseenter) ="isHover = true"
  (mouseleave) ="isHover = false"
>
  <ng-content></ng-content>
</uni-text-body>
